// extracted by mini-css-extract-plugin
export default {"header":"Modal_header__iznp9","subTitle":"Modal_subTitle__S3jMQ","body":"Modal_body__d0h8v"};